'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { Suspense, lazy, useMemo } from 'react';
import { useSchemes } from '@personly/libs-providers';
const Modal = lazy(() => import('react-modal'));
const Consent = ({ children, isOpen, consentLabel }) => {
    const { cssVariables } = useSchemes();
    const style = useMemo(() => ({
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            width: '80%',
            transform: 'translate(-50%, -50%)',
            boxShadow: '1px 2px 8px 0 rgba(0, 0, 0, 0.35)',
            border: 0,
            backgroundColor: cssVariables.cardBackgroundColor,
            maxWidth: '800px',
            maxHeight: '80%',
            overflowY: 'auto',
        },
        overlay: { backgroundColor: 'rgba(17, 17, 17, 0.5)' },
    }), [cssVariables]);
    return (_jsx(Suspense, { children: _jsx(Modal, { ariaHideApp: false, isOpen: isOpen, style: style, contentLabel: consentLabel, shouldCloseOnOverlayClick: false, shouldCloseOnEsc: false, children: children }) }));
};
export default Consent;
